import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HealthAndSafetyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"health_and_safety"}/>
}
